<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Ссылки </span>
      </div>
      <v-btn @click="goToCreate" style="width: auto !important" class="button-accept">
        + Добавить ссылку
      </v-btn>
    </div>

    <div style="height: calc(100vh - 190px); overflow: auto">
      <v-data-table :headers="tableHeaders" :items="items" item-key="id" :show-select="false" :disable-pagination="true"
        :hide-default-footer="true" :hide-default-header="true">
        <template v-slot:header>
          <thead>
            <tr>
              <th v-for="(s, index) in tableHeaders" :key="index">
                <div style="margin-left: 24px" v-if="s.text == 'Метка'">
                  {{ s.text }}
                </div>
                <div v-else>
                  {{ s.text }}
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="props">
          <tbody>
            <tr v-for="(item, index) in props.items" :key="index" @click="goToDetail(item)">
              <td>
                <img v-if="item.image" style="width: 40px" :src="item.image" />
                <div v-else style="width: 40px"></div>
              </td>
              <td>
                <div class="d-flex align-center">
                  <v-icon v-if="!item.isVisible" small> mdi-eye-off </v-icon>
                  <div v-else style="width: 24px"></div>
                  <div :style="!item.isVisible ? 'margin-left: 8px' : ''">
                    {{ item.label }}
                  </div>
                </div>
              </td>
              <td>{{ item.title }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.link }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>

export default {
  data: () => ({
    items: [],
    tableHeaders: [
      {
        text: "Изображение",
        sortable: false,
        value: "image",
      },
      {
        text: "Метка",
        sortable: false,
        value: "label",
      },
      {
        text: "Заголовок",
        sortable: false,
        value: "title",
      },
      {
        text: "Описание",
        sortable: false,
        value: "description",
      },
      {
        text: "Ссылка",
        sortable: false,
        value: "link",
      },
    ],
  }),
  methods: {
    goToCreate() {
      this.$router.push({ name: "LinkCreate" });
    },

    goToDetail(item) {
      this.$router.push({ name: "LinkDetail", params: { id: item.id } });
    },

    getItems() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV5 + "/appeal/banner/list", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
          params: { page: 1, limit: 1000 },
        })
        .then((res) => {
          this.items = res.data.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    this.getItems();
  },
};
</script>
<style lang="scss" scoped></style>
